import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getSections,
  addSection,
  updateSection,
  deleteSection,
} from "./sections.ducks";
import _ from "lodash";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import { withTranslation } from 'react-i18next';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const defaultColors = [
  "#FF5733",
  "#33B5FF",
  "#4CAF50",
  "#FF33F5",
  "#FFB533",
  "#8E33FF",
  "#33FFF5",
  "#FF3333",
];

class SectionsCreche extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      editingId: null,
      nom: "",
      description: "",
      couleur: "#FF5733",
      capacite: "",
      ordreAffichage: "",
    };
  }

  componentDidMount() {
    this.props.getSections(localStorage.getItem("token"));
  }

  resetForm = () => {
    this.setState({
      showForm: false,
      editingId: null,
      nom: "",
      description: "",
      couleur: "#FF5733",
      capacite: "",
      ordreAffichage: "",
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const tok = localStorage.getItem("token");
    const data = {
      nom: this.state.nom,
      description: this.state.description || null,
      couleur: this.state.couleur || null,
      capacite: this.state.capacite ? parseInt(this.state.capacite) : null,
      ordreAffichage: this.state.ordreAffichage
        ? parseInt(this.state.ordreAffichage)
        : null,
    };
    if (this.state.editingId) {
      this.props.updateSection(tok, this.state.editingId, data);
    } else {
      this.props.addSection(tok, data);
    }
    this.resetForm();
  };

  handleEdit = (section) => {
    this.setState({
      showForm: true,
      editingId: section.id,
      nom: section.nom,
      description: section.description || "",
      couleur: section.couleur || "#FF5733",
      capacite: section.capacite || "",
      ordreAffichage: section.ordreAffichage || "",
    });
  };

  handleDelete = (sectionId) => {
    if (window.confirm(this.props.t('creche.confirm_delete_section'))) {
      this.props.deleteSection(localStorage.getItem("token"), sectionId);
    }
  };

  render() {
    const { sections, loading, t } = this.props;

    return (
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 style={{ margin: 0, fontWeight: 600, color: "#004cc5" }}>
            Sections
          </h4>
          {!this.state.showForm && (
            <button
              className="btn gradient"
              onClick={() => this.setState({ showForm: true })}
              style={{
                color: "#fff",
                border: "none",
                borderRadius: "50px",
                padding: "10px 25px",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              {this.props.t('creche.add_section')}
            </button>
          )}
        </div>

        {this.state.showForm && (
          <div
            style={{
              borderRadius: "20px",
              padding: "25px",
              boxShadow: "0 0 20px rgba(0,0,0,0.15)",
              background: "#fff",
              marginBottom: "20px",
            }}
          >
            <form onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="custom-label">{t('creche.section_nom')}</label>
                  <input
                    type="text"
                    className="form-control custom-input box-shadow"
                    value={this.state.nom}
                    onChange={(e) => this.setState({ nom: e.target.value })}
                    required
                    placeholder={t('creche.section_name_placeholder')}
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="custom-label">{t('creche.section_description')}</label>
                  <input
                    type="text"
                    className="form-control custom-input box-shadow"
                    value={this.state.description}
                    onChange={(e) =>
                      this.setState({ description: e.target.value })
                    }
                    placeholder={t('creche.section_description')}
                  />
                </div>
                <div className="col-md-2 mb-3">
                  <label className="custom-label">{t('creche.section_capacity')}</label>
                  <input
                    type="number"
                    className="form-control custom-input box-shadow"
                    value={this.state.capacite}
                    onChange={(e) =>
                      this.setState({ capacite: e.target.value })
                    }
                    min="1"
                    placeholder={t('creche.section_max')}
                  />
                </div>
                <div className="col-md-2 mb-3">
                  <label className="custom-label">{t('creche.section_order')}</label>
                  <input
                    type="number"
                    className="form-control custom-input box-shadow"
                    value={this.state.ordreAffichage}
                    onChange={(e) =>
                      this.setState({ ordreAffichage: e.target.value })
                    }
                    min="1"
                    placeholder={t('creche.section_order')}
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6 mb-3">
                  <label className="custom-label">{t('creche.section_color')}</label>
                  <div className="d-flex align-items-center mt-1">
                    <input
                      type="color"
                      value={this.state.couleur}
                      onChange={(e) =>
                        this.setState({ couleur: e.target.value })
                      }
                      style={{
                        width: "40px",
                        height: "40px",
                        border: "none",
                        cursor: "pointer",
                        marginRight: "15px",
                        borderRadius: "50%",
                      }}
                    />
                    {defaultColors.map((color) => (
                      <span
                        key={color}
                        onClick={() => this.setState({ couleur: color })}
                        style={{
                          width: "28px",
                          height: "28px",
                          borderRadius: "50%",
                          backgroundColor: color,
                          display: "inline-block",
                          margin: "0 4px",
                          cursor: "pointer",
                          border:
                            this.state.couleur === color
                              ? "3px solid #333"
                              : "3px solid transparent",
                          transition: "all ease-in-out 0.2s",
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <div className="mt-3 d-flex">
                <button
                  type="submit"
                  className="btn gradient mr-3"
                  style={{
                    color: "#fff",
                    border: "none",
                    borderRadius: "50px",
                    padding: "10px 30px",
                    fontWeight: 600,
                  }}
                >
                  {this.state.editingId ? t('common.modify') : t('common.add')}
                </button>
                <button
                  type="button"
                  className="btn"
                  onClick={this.resetForm}
                  style={{
                    borderRadius: "50px",
                    padding: "10px 30px",
                    fontWeight: 600,
                    border: "1px solid #999",
                    color: "#999",
                  }}
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        )}

        <DotLoader
          size={60}
          color={"#ff7d26"}
          css={override}
          loading={loading}
        />

        {!loading && _.isEmpty(sections) && (
          <div className="text-center py-4" style={{ color: "#999", fontSize: "16px" }}>
            Aucune section. Créez des sections pour organiser les enfants.
          </div>
        )}

        {!_.isEmpty(sections) && (
          <div className="row">
            {sections.map((section) => (
              <div key={section.id} className="col-md-4 mb-3">
                <div
                  style={{
                    borderRadius: "20px",
                    borderLeft: `5px solid ${section.couleur || "#ccc"}`,
                    overflow: "hidden",
                    boxShadow: "0 0 20px rgba(0,0,0,0.1)",
                    background: "#fff",
                    padding: "20px",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h5
                        style={{
                          margin: "0 0 8px 0",
                          display: "flex",
                          alignItems: "center",
                          fontWeight: 600,
                        }}
                      >
                        <span
                          style={{
                            width: "14px",
                            height: "14px",
                            borderRadius: "50%",
                            backgroundColor: section.couleur || "#ccc",
                            display: "inline-block",
                            marginRight: "10px",
                            flexShrink: 0,
                          }}
                        />
                        {section.nom}
                      </h5>
                      {section.description && (
                        <p
                          style={{
                            fontSize: "14px",
                            color: "#999",
                            margin: "0 0 8px 0",
                          }}
                        >
                          {section.description}
                        </p>
                      )}
                      <p style={{ fontSize: "14px", margin: 0 }}>
                        <strong style={{ color: "#004cc5" }}>
                          {section.nbEnfants || 0}
                        </strong>{" "}
                        enfant
                        {(section.nbEnfants || 0) !== 1 ? "s" : ""}
                        {section.capacite && (
                          <span style={{ color: "#999" }}>
                            {" "}
                            / {section.capacite} max
                          </span>
                        )}
                      </p>
                    </div>
                    <div className="d-flex flex-column">
                      <button
                        className="btn btn-sm mb-1"
                        onClick={() => this.handleEdit(section)}
                        style={{
                          borderRadius: "50px",
                          fontSize: "12px",
                          fontWeight: 600,
                          border: "1px solid #004cc5",
                          color: "#004cc5",
                          padding: "4px 15px",
                        }}
                      >
                        Modifier
                      </button>
                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleDelete(section.id)}
                        style={{
                          borderRadius: "50px",
                          fontSize: "12px",
                          fontWeight: 600,
                          border: "1px solid #ff5b67",
                          color: "#ff5b67",
                          padding: "4px 15px",
                        }}
                      >
                        Supprimer
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  sections: state.gestionCreche.sections.data,
  loading: state.gestionCreche.sections.loading,
});

export default connect(mapStateToProps, {
getSections,
  addSection,
  updateSection,
  deleteSection,
})(withTranslation()(SectionsCreche));
